import { render, staticRenderFns } from "./fieldContactConsent.vue?vue&type=template&id=f13caaa4&lang=pug&"
import script from "./fieldContactConsent.vue?vue&type=script&lang=js&"
export * from "./fieldContactConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports